/**
 * Vetlyx Static Pages - Main JavaScript
 * Lightweight vanilla JS for essential interactions
 */

// Import modules
import { initAnchorRedirects } from './modules/anchor-redirects.js';
import { initMobileMenu } from './modules/mobile-menu.js';
import { initLanguageSwitcher } from './modules/language-switcher.js';
import { initFaqAccordion } from './modules/faq-accordion.js';
import { initHeroCarousel } from './modules/hero-carousel.js';
import { initSmoothScroll } from './modules/smooth-scroll.js';
import { initTabs } from './modules/tabs.js';
import { initHeaderDropdown } from './modules/header-dropdown.js';
import { initRegistrationModal } from './modules/registration-modal.js';
import { initResultModal } from './modules/result-modal.js';
import { initCTATracking } from './modules/cta-tracking.js';
import { initScrollAnimations } from './modules/scroll-animations.js';
import { initDownloadAnalytics } from './modules/download-analytics.js';

// Run anchor redirects immediately (before DOMContentLoaded)
initAnchorRedirects();

// Initialize all modules when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initLanguageSwitcher();
  initFaqAccordion();
  initHeroCarousel();
  initSmoothScroll();
  initTabs();
  initHeaderDropdown();
  initResultModal();
  initRegistrationModal();
  initCTATracking();
  initScrollAnimations();
  initDownloadAnalytics();
});
